/* Cosmic Vibez — reveal-on-scroll, gated for low-end devices.
   Content is visible by default (see cosmic.css). This only ARMS animation
   when the device can afford it. Bails on reduced-motion, Data Saver, 2G,
   <1GB RAM, <=2 cores, or no IntersectionObserver — leaving everything visible. */
(function () {
  'use strict';
  var root = document.documentElement;
  var conn = navigator.connection || navigator.webkitConnection || {};
  var lowEnd =
    (window.matchMedia && matchMedia('(prefers-reduced-motion:reduce)').matches) ||
    conn.saveData === true ||
    /(^|\b)(slow-)?2g$/.test(conn.effectiveType || '') ||
    (navigator.deviceMemory || 8) < 1 ||
    (navigator.hardwareConcurrency || 8) <= 2 ||
    !('IntersectionObserver' in window);

  if (lowEnd) { window.CV_LOWEND = true; root.classList.add('cv-lowend'); return; }

  root.classList.add('cv-anim');
  var io = new IntersectionObserver(function (entries) {
    for (var i = 0; i < entries.length; i++) {
      if (entries[i].isIntersecting) {
        entries[i].target.classList.add('cv-in');
        io.unobserve(entries[i].target);
      }
    }
  }, { rootMargin: '0px 0px -8% 0px', threshold: 0.12 });

  function bind() {
    var els = document.querySelectorAll('.cv-reveal:not(.cv-in)');
    for (var i = 0; i < els.length; i++) io.observe(els[i]);
  }
  bind();
  document.addEventListener('shopify:section:load', bind); // theme editor re-render
})();
